import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const MarketplacePage = lazy(() => import('../pages/marketplace/page'));
const OrdersPage = lazy(() => import('../pages/orders/page'));
const ConnectionsPage = lazy(() => import('../pages/connections/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const CompliancePage = lazy(() => import('../pages/compliance/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const UserDashboardPage = lazy(() => import('../pages/user-dashboard/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/marketplace',
    element: <MarketplacePage />
  },
  {
    path: '/orders',
    element: <OrdersPage />
  },
  {
    path: '/connections',
    element: <ConnectionsPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '/compliance',
    element: <CompliancePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/user-dashboard',
    element: <UserDashboardPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
